<template>
    <div>
      <h2 class="text-center thank-you-heading"> {{ title }}</h2>
      <p
        class="text-center paragraph"
        style="padding: 0px icon-customer-profil30px"
      >
        {{ message }}
      </p>

      <div class="row">
        <div class="col-12">
          <div class="row justify-content-center">
  
            <base-button
              btn-variant="primary"
              btn-label="Ok"
              @click.native="closeModal"
            >
  
            </base-button>
            
          </div>
        </div>
      </div>
      
    
    </div>
  </template>
  <script>
  import request from '@/utils/request'
  import PopupButton from '@/components/registration/PopupButton.vue'
  import { mapGetters } from 'vuex'
  
  export default {
    components: {
      PopupButton,
    },
  
    props: {
      title:{
        type: String,
        default: 'CNIC Already Registered',
      },
      message:{
        type: String,
        default: 'For further details kindly contact at contact@jsil.com',
      },
    },
  
    data() {
      return {
        otpCode: '',
        resendDisable: true,
        countDown: 120,
        responseData: '',
        isError: '',
        recaptchaResponse: '',
      }
    },
    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
      // ...mapState({
      //     userOcr: (state) => state.registration.useOcr,
      // }),
  
      ...mapGetters(['dataSegmentId', 'loading', 'form']),
  
      dataSegmentId() {
        if (this.$route.params.dataSegmentId) {
          return this.$route.params.dataSegmentId
        }
        return this.$store.getters.dataSegmentId
      },
    },
    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
  
    mounted() {
      this.countDownTimer()
      // console.log('PropsData: ' + JSON.stringify(this.data))
    },
    methods: {
        closeModal(){
          this.$emit('close');
        },
    },
  }
  </script>
  <style scoped>
  p {
    margin: 0;
    font-size: 16px;
    padding: 0px 20px;
  }
  .icon-tick-with-circle {
    color: green;
    font-size: 30px;
    cursor: pointer;
  }
  </style>
  